module.exports = __webpack_public_path__ + "static/media/MW.e89bc09e.png";